import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { BehaviorSubject, finalize, Observable } from 'rxjs';
import { EnvironmentToken } from '../../app.config';
import { Ranking, UserRanking } from '../models/ranking.model';

export class RankingService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;
  #isLoading = signal<Set<unknown>>(new Set());

  #rankings = new BehaviorSubject<Ranking[]>([]);

  public rankings$ = this.#rankings.asObservable();
  public rankings = toSignal(this.rankings$, {
    initialValue: [],
  });

  #userRankings = new BehaviorSubject<UserRanking[]>([]);

  public userRankings$ = this.#userRankings.asObservable();
  public userRankings = toSignal(this.userRankings$, {
    initialValue: [],
  });

  getRanking(params: { time_from: Date; time_to: Date }) {
    const httpParams = new HttpParams()
      .set('time_from', params.time_from.toISOString())
      .set('time_to', params.time_to.toISOString());
    this.#execute(
      this.#http.get<Ranking[]>(
        `${this.#apiUrl}/api/journey/user-rank`,
        { params: httpParams },
      ),
    ).subscribe({
      next: (ranking) => this.#rankings.next(ranking),
      error: (e) => console.log(e),
    });
  }
  getUserRanking(params: {
    time: string;
    sort: string;
    nickname?: string | null;
  }) {
    let httpParams = new HttpParams()
      .set('time', params.time)
      .set('sort', params.sort);

    if (params.nickname) {
      httpParams = httpParams.set('nickname', params.nickname);
    }

    this.#execute(
      this.#http.get<UserRanking[]>(
        `${this.#apiUrl}/api/journey/ranking`,
        { params: httpParams },
      ),
    ).subscribe({
      next: (ranking) => this.#userRankings.next(ranking),
      error: (e) => console.log(e),
    });
  }

  #execute<T = unknown>(apiCall: Observable<T>) {
    this.#isLoading.update((x) => {
      x.add(apiCall);
      return new Set(x.values());
    });
    return apiCall.pipe(
      finalize(() =>
        this.#isLoading.update((x) => {
          x.delete(apiCall);
          return new Set(x.values());
        }),
      ),
    );
  }
}
